<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->
<header class="slds-page-header">
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-title" style="min-width: 9rem">
      <div class="slds-media">
        <div class="slds-media__figure">
          <span class="slds-avatar slds-avatar_medium">
            <img alt="Track 4d Timesheet" src="/assets/accorto/timeSheet-100.svg">
          </span>
        </div>
        <div class="slds-media__body">
          <h1>
            <span class="slds-page-header__title slds-truncate" i18n id="ts-hdr">Timesheet</span>
            <span i18n>Weekly</span>
          </h1>
        </div>
      </div>
    </div>

    <div class="slds-page-header__col-actions">
      <div class="slds-page-header__controls">
        <div class="slds-page-header__control">
          <ul class="slds-grid slds-gutters_medium slds-wrap">
            <li class="slds-col slds-show_small">
              <button (click)="doSubmit()"
                      class="slds-button slds-button_neutral"
                      style="background-color: transparent"
                      id="ts-submit"
                      title="Submit Timesheet">
                <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#approval"
                       xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
                <span class="slds-show_medium" i18n>Submit</span>
              </button>
            </li>
            <li *ngIf="askWeekends"
                class="slds-col slds-show_medium">
              <label class="slds-checkbox_toggle slds-grid">
                <input (click)="onWeekendClick($event)"
                       [checked]="showWeekends"
                       aria-describedby="weekend-desc"
                       id="ts-weekend"
                       name="weekends"
                       type="checkbox" value="on"/>
                <span aria-live="assertive" class="slds-checkbox_faux_container" id="weekend-desc">
                  <span class="slds-checkbox_faux"></span>
                  <span class="slds-checkbox_on" i18n>Weekends</span>
                  <span class="slds-checkbox_off" i18n>Weekdays</span>
                </span>
              </label>
            </li>
            <li *ngIf="askDescriptions"
                class="slds-col slds-show_medium">
              <label class="slds-checkbox_toggle slds-grid">
                <input (click)="onDescriptionsClick($event)"
                       [checked]="showDescriptions"
                       aria-describedby="descriptions-desc"
                       id="ts-descriptions"
                       name="descriptions"
                       type="checkbox" value="on"/>
                <span aria-live="assertive" class="slds-checkbox_faux_container" id="descriptions-desc">
                  <span class="slds-checkbox_faux"></span>
                  <span class="slds-checkbox_on" i18n>Daily Description</span>
                  <span class="slds-checkbox_off" i18n>Daily Description</span>
                </span>
              </label>
            </li>
            <li class="slds-col slds-show_small">
              <button (click)="doRefresh()"
                      class="slds-button slds-button_icon slds-button_icon-border"
                      id="ts-refresh"
                      title="Refresh Timesheet">
                <svg aria-hidden="true" class="slds-button__icon">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#refresh"
                       xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
                <span class="slds-assistive-text" i18n>Refresh Timesheet</span>
              </button>
            </li>
            <li class="slds-col">
              <t4d-week-select (dateSelected)="doStartDate($event)"></t4d-week-select>
            </li>
          </ul>
        </div>
      </div>
    </div><!-- slds-page-header__col-actions -->

  </div><!-- slds-page-header__row -->

  <!-- status -->
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-meta">
      <acc-status-line [error]="error" [message]="message"></acc-status-line>
    </div>
  </div>
</header>

  <div class="slds-m-top_small slds-is-relative">
    <acc-data-table [records]="records"
                    [settings]="settings"
                    (saveRecords)="doSaveRecords($event)"
                    [ui]="ui">
    </acc-data-table>
    <acc-spinner *ngIf="busy"></acc-spinner>
</div>

